import  {Tooltip} from '../library/boostrap-native-v4'

const tooltip = {
	inserted: (el, binding) => {
		el.title = binding.value
		new Tooltip(el, {
			placement: Object.keys(binding.modifiers)[0],
		})
	},

	update: (el, binding) => {

		var style = window.getComputedStyle(el);

		if(style.display === 'none' || el.offsetParent === null){
			el.title = ""
			new Tooltip(el, {
				placement: Object.keys(binding.modifiers)[0],
			})
		}
	}
}

export default tooltip



// WEBPACK FOOTER //
// ./src/directives/tooltip.js